<template>
  <button
    :aria-label="label"
    @click="$emit('click')"
  >
    <i :class="iconClass" />
  </button>
</template>

<script>
export default {
  name: "InputButton",
  props: {
    icon: {
      type: String,
      required: true,
    },
    fill: {
      type: String,
      required: false,
      default: 'fas'
    },
    label: {
      type: String,
      required: true,
    },
  },
  computed:{
    iconClass() {
      return `${this.fill} fa-${this.icon} fa-lg`;
    }
  }
}
</script>

<style scoped>
button {
  top: 0.5rem;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.2s;
  padding: 0;
  background: transparent;
  border: 0;
}

button:hover {
  transform: scale(1.1);
}

button > i {
  color: #b1c6d0;
}
</style>